import React from 'react';
import { Redirect } from 'react-router-dom';

import { useStatsig } from '../../components/hooks/useStatsig';

const withImportedEventGate = (GatedComponent) => {
    const ImportedEventGate = (props) => {
        const { checkGate, featureGates } = useStatsig();
        const isImportedEventPagesEnabled = checkGate(featureGates.IMPORTED_EVENT_PAGES);

        if (!isImportedEventPagesEnabled) {
            return <Redirect to="/" />;
        }

        return <GatedComponent {...props} />;
    };

    ImportedEventGate.displayName = `ImportedEventGate(${GatedComponent.displayName || GatedComponent.name || 'Component'})`;

    return ImportedEventGate;
};

export default withImportedEventGate;
